/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Once_LabelInputs */

const es_landing_price_once_label = /** @type {(inputs: Landing_Price_Once_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago único · validez 5 años`)
};

const gl_landing_price_once_label = /** @type {(inputs: Landing_Price_Once_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago único · validez 5 anos`)
};

const en_landing_price_once_label = /** @type {(inputs: Landing_Price_Once_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-off payment · valid 5 years`)
};

/**
* | output |
* | --- |
* | "One-off payment · valid 5 years" |
*
* @param {Landing_Price_Once_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_once_label = /** @type {((inputs?: Landing_Price_Once_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Once_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_once_label(inputs)
	if (locale === "en") return en_landing_price_once_label(inputs)
	return es_landing_price_once_label(inputs)
});